// Password rules for local accounts (WRMM-134), shared by the API and the console (no Node imports here).
export const PASSWORD_MIN = 12, PASSWORD_MAX = 128;

// The commonest passwords that are at least 12 characters long; shorter ones already fail the length rule.
const COMMON = new Set(['123456789012', '1234567890123', '12345678901234', 'qwertyuiopas', 'qwertyuiop123', '1q2w3e4r5t6y',
  'password1234', 'password12345', 'password123456', 'passwordpassword', 'iloveyou1234', 'administrator', 'adminadminadmin',
  'welcome12345', 'welcome123456', 'letmein12345', 'changeme1234', 'wittcormm1234', 'qwerty123456', 'abcdefghijkl',
  'abc123abc123', 'aaaaaaaaaaaa', '111111111111', '000000000000', 'football1234', 'baseball1234', 'superman1234',
  'trustno1trustno1', 'sunshine1234', 'princess1234', 'monkey123456', 'dragon123456', 'michael12345', 'shadow123456']);

/**
 * Why a password isn't acceptable, or null (NIST SP 800-63B: length over composition; no forced character classes or
 * rotation): 12 to 128 characters, not the email or its name part, not one of the commonest, not one repeated character.
 */
export function passwordProblem(raw: string, email: string): string | null {
  // The rules apply to what is stored: passwords are hashed NFKC-normalized (full-width ａ is a).
  const password = raw.normalize('NFKC');
  const chars = [...password], length = chars.length; // Code points, not UTF-16 units (one emoji is one).
  if (length < PASSWORD_MIN) return `Use at least ${PASSWORD_MIN} characters.`;
  if (length > PASSWORD_MAX) return `Use at most ${PASSWORD_MAX} characters.`;
  const lower = password.toLowerCase(), local = email.toLowerCase().split('@')[0] ?? '';
  if (lower === email.toLowerCase() || (local.length >= 4 && lower.includes(local))) return 'Don’t use your email address in it.';
  if (COMMON.has(lower) || chars.every(c => c === chars[0])) return 'That password is too common. Choose another.';
  return null;
}
